<template>
  <base-layout :menuItems="menuItems">
    <template slot="content">
      <div class="w-full h-full overflow-y-auto" id="groovevideoCont">
        <transition :name="routerTransition">
          <router-view></router-view>
        </transition>
      </div>
    </template>
    <template slot="header-bar">
      <header-bar
        v-if="$route.meta.breadcrumb || $route.meta.pageTitle"
        :routeTitle="$t(routeTitle)"
      ></header-bar>
    </template>
    <template slot="sidebar">
      <sidebar-menu></sidebar-menu>
    </template>
  </base-layout>
</template>

<script>
import BaseLayout from '../design-system/account-adapter';
import store from '@/state';

export default {
  data() {
    return {
      isExternal: true,
      showSlider: false,
      routerTransition: 'zoom-fade',
      routeTitle: this.$route.meta.pageTitle,
      isAdmin: null,
      scrollbarSettings: {
        maxScrollbarLength: 60,
      },
    };
  },

  watch: {
    $route() {
      this.routeTitle = this.$route.meta.pageTitle;
    },
  },

  methods: {
    changeRouteTitle(title) {
      this.routeTitle = title;
    },
  },
  computed: {
    menuItems() {
      return [];
    },
  },
  async created() {
    this.isAdmin = store.state.user.admin;
  },
  components: {
    BaseLayout,
  },
};
</script>

<style scoped>
#groovevideoCont {
  height: calc(100vh - 4rem) !important;
}
</style>
